import React from 'react';
import SidebarHeader from '../../layout/SidebarHeader';
import TooltipIconButton from "components/TooltipIconButton";
import { DeleteOutline, ArrowBack } from '@mui/icons-material';

const Header = ({ onClose, onBack, onDelete, deleteDisabled }) =>(
  <SidebarHeader onClose={onClose}>
    <TooltipIconButton title="Delete" aria-label="delete" placement="bottom" onClick={onDelete} size={44} disabled={deleteDisabled}>
      <DeleteOutline />
    </TooltipIconButton>
    <TooltipIconButton title="Back" ariaLabel="back" placement="bottom" onClick={onBack} size={44}>
      <ArrowBack />
    </TooltipIconButton>
  </SidebarHeader>
)

export default Header;